// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"37f46595","270":"55f97bf4","307":"cc58c016","453":"23cf0830","535":"393259cb","545":"d368b0fe","568":"1f18136b","620":"f0087608","707":"192c769a","715":"c1b210e5"}[chunkId] + ".chunk.js";
};